import type { ValidationViolation } from '@mtg-deck-tool/shared';

interface ValidationBannerProps {
  violations: ValidationViolation[];
}

export function ValidationBanner({ violations }: ValidationBannerProps) {
  if (violations.length === 0) return null;

  const errors = violations.filter((v) => v.severity === 'error');
  const warnings = violations.filter((v) => v.severity === 'warning');

  return (
    <div className="mx-3 mt-2 space-y-1.5">
      {errors.map((v, i) => (
        <div key={i} className="flex items-start gap-2 bg-red-950/50 border border-red-800 rounded-lg px-3 py-2">
          <span className="text-red-400 shrink-0 text-xs mt-0.5">✖</span>
          <p className="text-xs text-red-300 leading-snug">{v.message}</p>
        </div>
      ))}
      {warnings.map((v, i) => (
        <div key={i} className="flex items-start gap-2 bg-yellow-950/40 border border-yellow-800/60 rounded-lg px-3 py-2">
          <span className="text-yellow-400 shrink-0 text-xs mt-0.5">⚠</span>
          <p className="text-xs text-yellow-300 leading-snug">{v.message}</p>
        </div>
      ))}
    </div>
  );
}
